import { render } from "./SaveJobTitle.vue?vue&type=template&id=ffbc6f4c"
import script from "./SaveJobTitle.vue?vue&type=script&lang=js"
export * from "./SaveJobTitle.vue?vue&type=script&lang=js"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__